import type { Request } from '../../../types';
import type { SavedAttachment } from '../../../services/attachmentService';
import type { SelectedFile } from '../../../components/forms/FileUpload';

export interface MonitoringManagementInitialProps {
  formData: Record<string, unknown>;
  updateFormData: (field: string, value: string) => void;
  requestId?: string;
  disabled?: boolean;
  attachmentsBySection?: Record<string, SavedAttachment[]>;
  onAttachFiles?: (sectionId: string) => void;
  onDeleteAttachment?: (attachmentId: number) => void;
  isEditing?: boolean;
  selectedFiles?: Record<string, SelectedFile[]>;
  onFilesSelected?: (sectionId: string, files: SelectedFile[]) => void;
  offlineMode?: boolean;
}

export interface MonitoringManagementPersistedProps {
  request: Request;
  isEditing: boolean;
  editedData: Record<string, unknown>;
  updateEditedData: (field: string, value: string) => void;
  showFullDetails?: boolean;
  showViewToggle?: boolean;
  isAdvancedView?: boolean;
  onToggleView?: () => void;
  attachmentsBySection?: Record<string, SavedAttachment[]>;
  onAttachFiles?: (sectionId: string) => void;
  onDeleteAttachment?: (attachmentId: number) => void;
  selectedFiles?: Record<string, SelectedFile[]>;
  onFilesSelected?: (sectionId: string, files: SelectedFile[]) => void;
  offlineMode?: boolean;
  onCaptionChange?: (attachmentId: number, caption: string) => void;
  pendingCaptionEdits?: Record<number, string>;
}

export type MonitoringManagementProps = MonitoringManagementInitialProps | MonitoringManagementPersistedProps;

export function isMonitoringManagementPersistedProps(
  p: MonitoringManagementProps,
): p is MonitoringManagementPersistedProps {
  return 'request' in p && (p as MonitoringManagementPersistedProps).request != null;
}
